
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StudentOnboardingComponent } from './student-onboarding/student-onboarding.component';
import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { StudentEnrollmentComponent } from './student-enrollment/student-enrollment.component';

const routes: Routes = [
  { path: '', redirectTo: '/student-dashboard', pathMatch: 'full' },
  // { path: '', redirectTo: '/home/dashboard', pathMatch: 'full' }, 

  
  {
    path: '',
    children: [
  {
    path: 'home',
    loadChildren: () => import('./student-dashboard/student-dashboard.module').then(m => m.StudentDashboardModule)
  },
 {
   path: 'student-new-dashboard',
      loadChildren: () => import('./student-dashboard/student-new-dashboard/student-new-dashboard.component').then(m => m.StudentNewDashboardComponent)
      },
  {
    path: 'tasks',
    loadChildren: () => import('./taskboard/taskboard.module').then(m => m.TaskboardModule)
  },
  {
    path: 'learn',
    loadChildren: () => import('./learn/learn.module').then(m => m.LearnModule)
  },
  {
    path: 'jobs',
    loadChildren: () => import('./jobs/jobs.module').then(m => m.JobsModule)
  },
  {
    path: 'planner',
    loadChildren: () => import('./planner/planner.module').then(m => m.PlannerModule)
  },
  {
    path: 'resource',
    loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule)
  },
  {
    path: '',
    loadChildren: () => import('./refer-to-frnd/refer-to-frnd.module').then(m => m.ReferToFrndModule)
  },
  {
    path:'assignments',
    loadChildren: () => import('./assignment/assignment.module').then(m =>m.AssignmentModule)
  },
  {
    path:'',
    loadChildren: () => import('./assignment/assignment.module').then(m =>m.AssignmentModule)
  },
  {
    path:'',
    loadChildren: () => import('./student-lms/student-lms.module').then(m =>m.StudentLmsModule)
  },
  {
    path:'onboarding',component:StudentOnboardingComponent
  },
  {
    path:'onboarding-form',component:StudentOnboardingComponent
  },
  {
    path:'student-dashboard',component:MainDashboardComponent
  },
  {
    path:'student-enrollment/:id',component:StudentEnrollmentComponent
  },

 
]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentRoutingModule { }
